module.exports = __webpack_public_path__ + "static/media/store.471f0c64.svg";